'use client';

import { useMemo, useCallback } from 'react';
import { useRouter, useSearchParams, usePathname } from 'next/navigation';

//* Helpers
import { createQueryString } from '@/helpers/_functions';

//* Components
import Page from '@/components/common/Page';
import Container from '@/components/common/Container';
import BlogItem from '@/components/pages/blog/BlogItem';
import Pagination from '@/components/common/Pagination';

//* Style
import BlogStyle from 'styles/pages/BlogStyle';

const Blog = ({ posts, total, pageSize }) => {
    //! Router
    const searchParams = useSearchParams();
    const pathname = usePathname();
    const router = useRouter();

    //! On Filter Param Change
    const onFilterChange = useCallback(
        (type, typeId, multiple = false) => {
            const params = createQueryString({ type, typeId, multiple, searchParams });

            router.push(pathname + '?' + params);
        },
        [searchParams]
    );

    //! Blog items
    const storeBlogItems = useMemo(() => {
        return posts.map((item, index) => (
            <BlogItem
                key={index}
                index={index}
                {...item}
            />
        ));
    }, [posts]);

    return (
        <Page className='blog'>
            <BlogStyle>
                <Container
                    section
                    className={'blogs-container'}>
                    <div className='items-wrap'>{storeBlogItems}</div>

                    <Pagination
                        total={total}
                        pageSize={pageSize}
                        onCategoryChange={onFilterChange}
                    />
                </Container>
            </BlogStyle>
        </Page>
    );
};

export default Blog;
